export class ApAlert {
  id = '';
  htmlBaseId?: string;
  type?: ApAlertType;
  message = '';
  autoClose = false;
  autoCloseTimeout = 5000;
  fade = false;

  constructor(init?: Partial<ApAlert>) {
    Object.assign(this, init);
  }
}

export enum ApAlertType {
  Success,
  Error,
  Warning,
  Info,
}
